<template lang="html">
  <AnimalForm adminmethod="new" />
</template>

<script>
import AnimalForm from './AnimalForm.vue';

export default {
  components: {
    AnimalForm,
  }
}
</script>

<style lang="scss" scoped>
</style>
